import React from 'react'
import { motion } from 'framer-motion'

import circle from '../../assets/images/remittances/red-circle.svg'
import widget from '../../assets/images/remittances/widget.svg'
import RedCardBlock from '../../components/red-card-block/RedCardBlock'
import { RemittancesAccordion, RemittancesHeader } from './components'
import Animations from '../../utils/animations'
import useStyles from './Remittances.styles'

export default function Remittances () {
  const classes = useStyles()

  return (
    <div>
      <RemittancesHeader />
      <div
        className={classes.imagesContainer}
      >
        <motion.img src={circle} {...Animations.FADE()} />
        <motion.img src={widget} />
      </div>
      <RemittancesAccordion />
      <div>
        <h2 className={classes.redTitle}>Fast. Secure. Worldwide.</h2>
      </div>
      <RedCardBlock title='Send money abroad!' buttonText='Contact us' goToPlatform />
    </div>
  )
}
